import {
  Body1,
  Bold,
  Box,
  Display,
  FlexDirection,
  Icon,
  IconVariant,
  Link,
  Space,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { InlineLink } from '../../InlineLink/InlineLink'

export const EnvironmentalBenefitsCopyWithUrl = ({
  ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL,
}: {
  ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL: {
    firstLine: string
    secondLine: string
    thirdLine: string
    fourthLine: string
    url: string
  }
}) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Row}>
    <Icon name="tick" variant={IconVariant.Confirmation} />
    <Space direction="horizontal" size={1} />
    <Body1>
      <Bold>{ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL.firstLine}</Bold>{' '}
      <InlineLink href={ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL.url} backgroundStyle="light">
        <Bold>{ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL.secondLine}</Bold>
      </InlineLink>{' '}
      <Bold>{ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL.thirdLine}</Bold>{' '}
      {ENVIRONMENTAL_BENEFITS_BULLET_WITH_URL.fourthLine}
    </Body1>
  </Box>
)
